import { RootState } from "../../../../index";

export const userListigData = (state: RootState) =>
  state?.user?.data?.allUserListing;
export const userRoles = (state: RootState) => state?.user?.data?.userRoles;
export const userListingCount = (state: RootState) => state?.user?.data?.allUserListingCount
